import script from "./SystemLogView.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemLogView.vue?vue&type=script&setup=true&lang=js"

import "./SystemLogView.vue?vue&type=style&index=0&id=7adb47a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7adb47a6"]])

export default __exports__